import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-deep text-white mt-24" data-id="element-22">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-23">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-24">
          {/* Services */}
          <div data-id="element-25">
            <h3 className="text-lg font-bold mb-4" data-id="element-26">Services</h3>
            <ul className="space-y-2" data-id="element-27">
              <li data-id="element-28">
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors" data-id="element-29">
                  Custom Web Development
                </Link>
              </li>
              <li data-id="element-30">
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors" data-id="element-31">
                  Mobile Applications
                </Link>
              </li>
              <li data-id="element-32">
                <Link to="/ai-automation" className="text-gray-300 hover:text-white transition-colors" data-id="element-33">
                  AI & Automation
                </Link>
              </li>
              <li data-id="element-34">
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors" data-id="element-35">
                  Database Solutions
                </Link>
              </li>
              <li data-id="element-36">
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors" data-id="element-37">
                  System Integrations
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-38">
            <h3 className="text-lg font-bold mb-4" data-id="element-39">Company</h3>
            <ul className="space-y-2" data-id="element-40">
              <li data-id="element-41">
                <Link to="/" className="text-gray-300 hover:text-white transition-colors" data-id="element-42">
                  About
                </Link>
              </li>
              <li data-id="element-43">
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors" data-id="element-44">
                  Contact
                </Link>
              </li>
              <li data-id="element-45">
                <Link to="/support" className="text-gray-300 hover:text-white transition-colors" data-id="element-46">
                  Client Support
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-47">
            <h3 className="text-lg font-bold mb-4" data-id="element-48">Legal</h3>
            <ul className="space-y-2" data-id="element-49">
              <li data-id="element-50">
                <a href="#" className="text-gray-300 hover:text-white transition-colors" data-id="element-51">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-52">
            <h3 className="text-lg font-bold mb-4" data-id="element-53">Contact</h3>
            <div className="space-y-2 text-gray-300" data-id="element-54">
              <p data-id="element-55">Magnus Software</p>
              <p data-id="element-56">Custom Software Development</p>
              <p className="mt-4" data-id="element-57">
                <a href="tel:231-266-0606" className="hover:text-white transition-colors" data-id="element-58">
                  231-266-0606
                </a>
              </p>
              <p className="text-sm" data-id="element-59">New projects by referral only</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 text-center text-gray-400 text-sm" data-id="element-60">
          <p data-id="element-61">
            &copy; {new Date().getFullYear()} Magnus Software. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}